"use client";

export default function LegalContent({ status, html, subject = "content" }) {
  if (status === "loading") {
    return (
      <div className="flex justify-center items-center py-24">
        <div className="animate-spin rounded-full h-10 w-10 border-2 border-gray-200 border-t-[#282886]" />
      </div>
    );
  }

  if (status === "failed") {
    return (
      <div className="text-center py-20">
        <p className="text-[15px] text-red-500">
          Failed to load {subject}. Please try again later.
        </p>
      </div>
    );
  }

  if (html) {
    return (
      <article
        dangerouslySetInnerHTML={{ __html: html }}
        className="
          prose prose-slate max-w-none
          prose-headings:font-semibold prose-headings:tracking-tight prose-headings:text-[#0B0B0B]
          prose-h1:text-3xl prose-h1:mb-6
          prose-h2:text-2xl prose-h2:mt-12 prose-h2:mb-4
          prose-h3:text-lg prose-h3:mt-8
          prose-p:text-[15px] prose-p:leading-7 prose-p:text-[#444]
          prose-li:text-[15px] prose-li:leading-7 prose-li:text-[#444] prose-li:marker:text-[#282886]
          prose-a:text-[#282886] prose-a:font-medium prose-a:no-underline hover:prose-a:underline
          prose-strong:text-[#0B0B0B] prose-strong:font-semibold
          prose-hr:border-gray-100
        "
      />
    );
  }

  return (
    <div className="text-center py-20">
      <p className="text-[15px] text-gray-500">{subject} not available.</p>
    </div>
  );
}
